import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import {translate} from "admin-on-rest";

const defaultStyle = {
    dropZone: {
        background: '#efefef',
        cursor: 'pointer',
        padding: '1rem',
        textAlign: 'center',
        color: '#999',
    },
    preview: {
        float: 'left',
    },
};

export class FileInput extends Component {
    static propTypes = {
        accept: PropTypes.string,
        children: PropTypes.element,
        disableClick: PropTypes.bool,
        elStyle: PropTypes.object,
        input: PropTypes.object,
        itemStyle: PropTypes.object,
        labelMultiple: PropTypes.string,
        labelSingle: PropTypes.string,
        maxSize: PropTypes.number,
        minSize: PropTypes.number,
        multiple: PropTypes.bool,
        removeStyle: PropTypes.object,
        style: PropTypes.object,
        translate: PropTypes.func.isRequired,
        placeholder: PropTypes.node,
    };

    static defaultProps = {
        addLabel: true,
        addField: true,
        itemStyle: {},
        multiple: false,
        onUpload: () => {},
        removeStyle: { display: 'inline-block' },
    };

    constructor(props) {
        super(props);
        let files = (props.input && props.input.value) || [];
        if (!Array.isArray(files)) {
            files = [files];
        }

        this.state = {
            files: files.map(this.transformFile),
        };
    }

    componentWillReceiveProps(nextProps) {
        let files = (nextProps.input && nextProps.input.value) || [];
        if (!Array.isArray(files)) {
            files = [files];
        }

        this.setState({ files: files.map(this.transformFile) });
    }

    onDrop = files => {
        const updatedFiles = this.props.multiple
            ? [...this.state.files, ...files.map(this.transformFile)]
            : [...files.map(this.transformFile)];

        this.setState({ files: updatedFiles });
        this.props.onChange(updatedFiles);
    };

    // turn a browser dropped file structure into expected structure
    transformFile = file => {
        if (!(file instanceof File)) {
            return file;
        }

        const transformedFile = {
            rawFile: file,
            src: file.preview,
            title: file.name
        };

        return transformedFile;
    };

    render() {
        const {
            accept,
            disableClick,
            elStyle,
            maxSize,
            minSize,
            multiple,
            style,
            label
        } = this.props;

        const finalStyle = {
            ...defaultStyle,
            ...style,
        };

        return (
            <div style={elStyle}>
                <Dropzone
                    onDrop={this.onDrop}
                    accept={accept}
                    disableClick={disableClick}
                    maxSize={maxSize}
                    minSize={minSize}
                    multiple={multiple}
                    style={finalStyle.dropZone}
                >
                    {label}
                </Dropzone>
            </div>
        );
    }
}

export default translate(FileInput);



// WEBPACK FOOTER //
// ./src/components/CRM/UploadFileInput.js